import { render, staticRenderFns } from "./OverlayPageLink.vue?vue&type=template&id=03756472"
import script from "./OverlayPageLink.vue?vue&type=script&lang=js"
export * from "./OverlayPageLink.vue?vue&type=script&lang=js"
import style0 from "./OverlayPageLink.vue?vue&type=style&index=0&id=03756472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports